import React from 'react'
import PropTypes from 'prop-types'

import pic01 from '../images/pic01.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg'
import picStone from '../images/stone.jpg'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div ref={this.props.setWrapperRef} id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="intro" className={`${this.props.article === 'intro' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Intro</h2>
          <span className="image main"><img src={pic01} alt="" /></span>
          <p>Reno Lodge #13 Free and Accepted Masons was charted by the Most Worshipful Grand Lodge of Nevada on September 23rd, 1869. Reno 13 is the oldest Freemason's lodge in Reno, Nevada, and we are often referred to as the "Lodge of Leadership."</p>
          <p>The purpose of Reno 13 is to enrich the city of Reno and the State of Nevada by working to make good men better in the environment of a Fraternal Brotherhood. We actively support our community with various charitable causes and seek to teach a system of morality that is veiled in allegory.</p>
          {close}
        </article>

        <article id="work" className={`${this.props.article === 'work' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Work</h2>
          <span className="image main"><img src={pic02} alt="" /></span>
          <p>Reno Lodge 13 supports various masonic youth organizations.</p>
          <p>We are a proud sponsor of the Bikes for Books program, supporter of PRoject Santa, and provide multiple scholarships for local graduating high school students. </p>
          {close}
        </article>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">About</h2>
          <span className="image main">
            <img src={pic03} alt="" />
            </span>
          <center>
          <p>Caleb Jensen – Worshipful Master</p>
          <p>Sean B. Freeman – Senior Warden</p>
          <p>Meynardo Yanzon Jr. – Junior Warden</p>
     {/* <p>Thomas Owens- Treasurer</p> */}
          <p>Charles Aglubat, PM – Secretary</p>
      {/*    <p>Michael P. Aurnague, PM – Chaplain</p>
          <p>Cris J. C. Santos – Senior Deacon</p>
          <p> — Junior Deacon</p>
          <p> – Senior Steward</p>
          <p>Michael Cloud – Junior Steward</p>
          <p>Richard L. Long – Marshall</p>
    */}
          <p>Guy S. Moreno, PM – Master of Ceremonies</p>
      {/*    <p>Kristopher Zierolf, PM – Historian</p>
          <p>Frank Jones – Tyler</p> + Deputy Grant Lecturer
  */}  
          <p>Kyle Pellet, PM - Deputy Grant Lecturer</p>
          </center>
          {close}
        </article>

        <article id="funerals" className={`${this.props.article === 'funerals' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Masonic Memorial Gardens</h2>
          <span className="image main"><img src={picStone} alt="Masonic Memorial Gardens" /></span>
          <p>Reno Lodge #13 Free and Accepted Masons operates a full service funeral center and cemetary. Masonic Memorial Gardens is located at 437 Stoker Ave, Reno, NV 89503. Facilities include a chapel, cremeatory and mausoleum.</p>
          <p>The property exists to serve the final needs of the Masonic family. For information recording Masonic Memorial Gardens, please call: 775.329.2635 or 775.322.1933</p>
          {close}
        </article>

        <article id="contact" className={`${this.props.article === 'contact' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Contact</h2>
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSd4HjluHHCyF6CDAzgFMNmGxkSW_Ak9HBaVjk59M0tBsA9Dhg/viewform?embedded=true" width="640" height="932" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>

          <ul className="icons">
            <li><a href="#" className="icon fa-twitter"><span className="label">Twitter</span></a></li>
            <li><a href="#" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
            <li><a href="#" className="icon fa-instagram"><span className="label">Instagram</span></a></li>
          </ul>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
